"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAcceptInvitationMutation = exports.useGetInvitationByTokenQuery = exports.useCancelInvitationMutation = exports.useResendInvitationMutation = exports.useInviteClientMutation = exports.useGetClientInvitationsQuery = exports.clientInvitationApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var api_url_1 = require("../../utils/api-url");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.clientInvitationApi = (0, react_1.createApi)({
    reducerPath: "clientInvitationApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["client-invitation"],
    endpoints: function (builder) { return ({
        getClientInvitations: builder.query({
            query: function (request) {
                return (0, api_url_1.appendUrlParams)("/v1/client-invitation", {
                    size: request.size,
                    pageNumber: request.pageNumber,
                    search: request.search,
                    status: request.statuses,
                    sortBy: request.sortBy,
                    sortDirection: request.sortDirection,
                });
            },
            providesTags: ["client-invitation"],
        }),
        inviteClient: builder.mutation({
            query: function (body) { return ({ url: "/v1/client-invitation", method: "POST", body: body }); },
            invalidatesTags: ["client-invitation"],
        }),
        resendInvitation: builder.mutation({
            query: function (id) { return ({ url: "/v1/client-invitation/".concat(id, "/resend"), method: "PATCH" }); },
            invalidatesTags: ["client-invitation"],
        }),
        cancelInvitation: builder.mutation({
            query: function (id) { return ({ url: "/v1/client-invitation/".concat(id, "/cancel"), method: "PATCH" }); },
            invalidatesTags: ["client-invitation"],
        }),
        getInvitationByToken: builder.query({
            query: function (token) { return "/v1/client-invitation/accept/".concat(token); },
        }),
        acceptInvitation: builder.mutation({
            query: function (_a) {
                var token = _a.token, body = _a.body;
                return ({ url: "/v1/client-invitation/accept/".concat(token), method: "POST", body: body });
            },
        }),
    }); },
});
exports.useGetClientInvitationsQuery = exports.clientInvitationApi.useGetClientInvitationsQuery, exports.useInviteClientMutation = exports.clientInvitationApi.useInviteClientMutation, exports.useResendInvitationMutation = exports.clientInvitationApi.useResendInvitationMutation, exports.useCancelInvitationMutation = exports.clientInvitationApi.useCancelInvitationMutation, exports.useGetInvitationByTokenQuery = exports.clientInvitationApi.useGetInvitationByTokenQuery, exports.useAcceptInvitationMutation = exports.clientInvitationApi.useAcceptInvitationMutation;
